<template>
  <LessonContent :title="lesson.title" :order="lesson.order">

     <form-wizard class="mt-3 lesson-wizard"  color="black" errorColor="rgba(var(--vs-danger), 1)" backButtonText="<" title="" subtitle="" nextButtonText=">" :finishButtonText="buttonTitle">

      <tab-content title="">
        <LessonTabContent>
              <span class="font-black text-6xl">Purpuseful routine</span>

              <div class="lesson-intro-image-wrapper">
               <img class="mx-auto p-4 lesson-intro-image" src="@/assets/images/academy/academy_popup_4.svg"/>
             </div>

        </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>

          <p>
           The wishing part is over.
          </p>

       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
          <p>
              Now it's time for actions, only them prove who you are.
          </p>

             <div class="w-1/3 mx-auto mt-4">
                <img src="@/assets/images/academy/aca_15.png"/>
            </div>
       </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>
            <p class="text-xl">Do you want to run a marathon? </p>
            <p class="">
              Then you should run.
            </p>
       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
            <p class="text-xl">Do you want to become a creator? </p>
            <p class="">
              Then you should write or draw.
            </p>

       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>

            <p class="text-xl">Do you want to become healthy?</p>
            <p>
              Then you should eat healthy.
            </p>


          <div class="mt-6">
            <p class="text-xl">Do you want to become an investor?</p>
            <p>
              Then you should invest.
            </p>
          </div>

          <div class="mt-6">
            <p class="text-xl">Do you want to be a happy person?</p>
            <p>
              Then you should do things that make you happy.
            </p>
          </div>
       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
          <p class="text-4xl">
            The point is clearly visible here, right?
          </p>

       </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>
          <p>
            You need to ask yourself:
           </p>

           <p class="text-4xl">
             What would that future self do?
           </p>
       </LessonTabContent>
      </tab-content>

       <tab-content title="">
        <LessonTabContent>


           <p>
            Then you need to <span class="font-semibold">step out of your comfort zone</span> and <span class="font-semibold">become that person</span> or at least pretend to be that person.
           </p>


   

       </LessonTabContent>
      </tab-content>


       <tab-content title="">
        <LessonTabContent>

              <div class="w-1/2 mx-auto">
                <img src="@/assets/images/academy/aca_16_2.png"/>
            </div>


       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
        <p>
            Notice that there isn't mentioned something like <span class="font-italic">hard work</span> or a specific amount of <span class="font-italic">time, effort or resources</span>.
           </p>
       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
           <p class="">
             You are meant to do something repeatedly and continuously toward your goals.
           </p>

       </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>
           <p>
             This builds a system, a routine throughout you grow and <span class="font-semibold">make yourself better every day</span>.
           </p>

           <p>
             Literally.
           </p>
       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
           <p>
             Forget about perfectionism once again and start with a routine that is so easy you can't say no.
           </p>
       </LessonTabContent>
      </tab-content>

        <tab-content title="">
        <LessonTabContent>
            <p>
            Start where you are.
          </p>

          <p>Use what you have.</p>

          <p>Do what you can.</p>

       </LessonTabContent>
      </tab-content>


        <tab-content title="" :beforeChange="saveAndExit">
        <LessonTabContent>




          <p><span class="">When action has a purpose, then it also has a result.</span></p>

          <div class="mt-2">
            <vs-button color="#5222D0" size="large" @click="redirectToActionBoard">create a routine</vs-button>
          </div>
       </LessonTabContent>
      </tab-content>
    </form-wizard>
  </LessonContent>

</template>

<script>
import LessonContent from './LessonContent'
import LessonTabContent from './LessonTabContent'
import { FormWizard, TabContent } from 'vue-form-wizard'
import LessonMixin from '../../Generic/LessonMixin'

export default {
  components: {
    LessonContent,
    LessonTabContent,
    TabContent,
    FormWizard
  },
  props: ['lesson'],
  mixins: [LessonMixin],
  data () {
    return {}
  },
  computed: {
  },
  methods: {
    redirectToActionBoard () {
      const routeData = this.$router.resolve({ name: 'planner', query: { initWithRoutineSidebarOpen: 'true'  }})
      window.open(routeData.href, '_blank')
    }
  },
}
</script>
